import { Navigate, Route, Routes } from 'react-router-dom';
import { LoginPage } from '../pages/LoginPage';
import { ProtectedLayout } from '../pages/ProtectedLayout';
import { DashboardPage } from '../pages/DashboardPage';
import { LocationsPage } from '../pages/LocationsPage';
import { RunsPage } from '../pages/RunsPage';
import { OnboardingPage } from '../pages/OnboardingPage';
import { BillingPage } from '../pages/BillingPage';
import { BrandingPage } from '../pages/BrandingPage';
import { UsersPage } from '../pages/UsersPage';
import { AdminPage } from '../pages/AdminPage';
import { ResetPasswordPage } from '../pages/ResetPasswordPage';

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/" element={<ProtectedLayout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="locations" element={<LocationsPage />} />
        <Route path="runs" element={<RunsPage />} />
        <Route path="onboarding" element={<OnboardingPage />} />
        <Route path="billing" element={<BillingPage />} />
        <Route path="branding" element={<BrandingPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="admin" element={<AdminPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
